import { GlobalStyles } from "@mui/material";

export const globalPrintStyles = (
  <GlobalStyles
    styles={{
      "@media print": {
        "@page": {
          paddingRight: 0,
          paddingLeft: 0,
          marginRight: 0,
          marginLeft: 0,
        },
      },
    }}
  />
);
